import { Sie4ExportApiClient } from '@/clients/sie4ExportApiClient';

export class Sie4ExportService {
  async exportCompanyData(companyName: string): Promise<void> {
    return Sie4ExportApiClient.exportSie4(companyName);
  }
}
